import LegalPageLayout from "../components/LegalPageLayout";

const highlights = [
  "By using this website, you agree to use it lawfully and only for genuine business or informational purposes.",
  "Website content is provided for general information and may be updated, removed or revised without prior notice.",
  "Any commercial transaction, quote or shipment is governed by separate written terms agreed between the parties.",
];

const sections = [
  {
    heading: "Use Of The Website",
    paragraphs: [
      "This website is provided for general informational purposes and to enable visitors to contact Vissera regarding its products and services. You agree not to misuse the site, attempt to disrupt its operation, gain unauthorised access to systems, or submit false, misleading or unlawful content through any form or communication channel.",
      "We may restrict, suspend or terminate access to the site if we believe use of the site breaches these terms or creates a risk to our systems, users or business operations.",
    ],
  },
  {
    heading: "Content And Intellectual Property",
    paragraphs: [
      "All site content, including text, branding, graphics, layout and downloadable materials, is owned by or licensed to Vissera unless otherwise stated. You may view and use this content for personal or internal business reference, but you may not copy, republish, distribute or modify it for commercial use without prior written permission.",
      "References to products, services, certifications or market information are provided in good faith, but should not be treated as a binding offer unless expressly confirmed in writing.",
    ],
  },
  {
    heading: "Quotes, Orders And Liability",
    paragraphs: [
      "Any quotation, pricing indication, logistics plan or product availability shown on the website or discussed through initial communications is non-binding unless confirmed through an authorised written agreement. Final trade terms, delivery conditions, payment terms and compliance requirements are governed by the specific contract between the parties.",
      "To the fullest extent permitted by law, Vissera is not liable for indirect, incidental or consequential loss arising from use of the website, reliance on public website content, temporary service interruption or third-party links. Nothing in these terms excludes liability that cannot legally be excluded.",
    ],
  },
  {
    heading: "Governing Principles",
    paragraphs: [
      "These terms are interpreted in accordance with the laws applicable to Vissera's operations, unless a separate written agreement provides otherwise. If any provision of these terms is found unenforceable, the remaining provisions continue in effect.",
      "Questions about these terms may be directed to our team through the contact information published on this website.",
    ],
  },
];

export default function TermsConditions() {
  return (
    <LegalPageLayout
      eyebrow="TERMS & CONDITIONS"
      title={<>The rules for using the <span className="text-[#B8860B]">Vissera</span> website</>}
      intro="These terms describe how visitors may use our website, how site content should be understood and the limits that apply to public information and preliminary communications."
      lastUpdated="June 14, 2026"
      highlights={highlights}
      sections={sections}
    />
  );
}
